import { render, staticRenderFns } from "./IconLecard.vue?vue&type=template&id=1186097c&scoped=true"
import script from "./IconLecard.vue?vue&type=script&lang=js"
export * from "./IconLecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186097c",
  null
  
)

export default component.exports